import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaEnvelope, FaLock } from "react-icons/fa";
import "./astrologylogin.css";
import { useContext } from "react";
import AlertContext from "../../contexts/AlertContext";


const AstrologerLogin = () => {
  const navigate = useNavigate();
  const { showAlert } = useContext(AlertContext);
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const [error, setError] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const response = await fetch("https://back.varankal.com/api/astrologers/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || `HTTP Error: ${response.status}`);
      }

      showAlert("Login successful!");
      localStorage.setItem("token", data.token);
      setFormData({ email: "", password: "" });

      navigate("/homepage");
    } catch (error) {
      console.error("Login Error:", error);
      showAlert("Invalid email or password. Please try again.", "error");
    }
  };

  return (
    <div className="outer-containerL77">
      <div className="login-containerL77">
        <h2>Astrologer Login</h2>
        {error && <p className="error-messageL77">{error}</p>}

        <form onSubmit={handleSubmit}>
          <div className="input-groupL77">
            <FaEnvelope className="input-iconL77" />
            <input
              className="inputL77"
              type="email"
              name="email"
              placeholder="Email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="input-groupL77">
            <FaLock className="input-iconL77" />
            <input
              className="inputL77"
              type="password"
              name="password"
              placeholder="Password"
              value={formData.password}
              onChange={handleChange}
              required
            />
          </div>

          <button className="buttonL77" type="submit">
            Login
          </button>
        </form>
      </div>
    </div>
  );
};

export default AstrologerLogin;
